import React, { PropsWithChildren } from "react";

import styles from "./AppSmallHeading.module.css";

interface SmallHeadingProps extends PropsWithChildren {
    for: string | undefined;
    centered?: boolean;
    required?: boolean;
    allCaps?: boolean;

}

export default function SmallHeading(props: SmallHeadingProps): JSX.Element {
    return (
        <div className={`${props.centered && styles.centered} ${props.allCaps && styles.allCaps}`}>
            <label className={styles.headingSmall} htmlFor={props.for}>{props.children} {props.required && <div className={styles.required}>*</div>}</label>
        </div>
    )
}